
import { computed, defineComponent, PropType } from 'vue'

// @components
import CargoStatus from '@/modules/NewDispatcher/components/CargoStatus/index.vue'
import TakeTableRowActions from '@/modules/NewDispatcher/components/TakeTableRowActions/index.vue'
import Cheap from '@/common/components/UI/Cheap/index.vue'

// @helpers
import cut from '@/common/helpers/cut'

import { formatDateWithTimeFromBackend, formatDateFromBackend } from '@/common/helpers/formatDate'

export default defineComponent({
    name: 'takes-table-row',
    components: {
        CargoStatus,
        TakeTableRowActions,
        Cheap,
    },
    props: {
        row: {
            type: Object as PropType<any>,
            default: null,
        },
        column: {
            type: Object as PropType<any>,
            default: null,
        },
        isCanAssign: {
            type: Boolean,
            default: false,
        },
        isCanChangeDate: {
            type: Boolean,
            default: false,
        },
        isCanSetWaitList: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['assign-order', 'change-date', 'wait-list', 'shortcoming', 'payment', 'resend'],
    setup(props, { emit }) {
        const emitAssignOrder = () => emit('assign-order', { ...props.row })
        const emitChangeDate = () => emit('change-date', { ...props.row })
        const emitWaitList = () => emit('wait-list', { ...props.row })
        const emitShortcoming = () => emit('shortcoming', { ...props.row })
        const emitPayment = (type: number) => emit('payment', type, { ...props.row })
        const emitResend = () => emit('resend', { ...props.row })

        const getCheckOrTimesIcon = (is_check: boolean) => {
            return `fas ${is_check ? 'fa-check text-green-500' : 'fa-times'}`
        }

        const isWaitListId = computed(() => {
            return (
                props.column.key === 'waitListId' &&
                props.row.waitList &&
                props.row.waitList.state &&
                [48, 49].includes(props.row.waitList.state.id)
            )
        })

        return {
            emitAssignOrder,
            emitChangeDate,
            emitWaitList,
            emitShortcoming,
            emitPayment,
            cut,
            getCheckOrTimesIcon,
            emitResend,
            //
            isWaitListId,
            formatDateWithTimeFromBackend,
            formatDateFromBackend
        }
    },
})
